import { HeaderItem } from '../types';

export const createRel = (item?: HeaderItem) => {
  return `noopener noreferer ${item?.notIndexed ? 'nofollow' : ''}`;
};
